import { PropertyDeclarations, css, html } from 'lit';

import { BaseAtomElement } from './base/BaseAtomElement.js';
import { SkeletonShapeComponentProp } from '../types/props.js';

const DEFAULT_WIDTH = '36px';

/**
 *  Skeleton for shaped elements.
 *
 */
export class VeneerSkeletonShape extends BaseAtomElement {
  declare shape?: SkeletonShapeComponentProp;

  static override properties: PropertyDeclarations = {
    /**
     * Sets the shape element's shape.
     * @values rectangle, ellipse
     */
    shape: { type: String, reflect: true },
    /**
     * Sets the shape element's height.
     */
    height: { type: String },
    /**
     * Sets the shape element's width.
     */
    width: { type: String },
  };

  constructor() {
    super();
    this.shape = 'rectangle';
  }

  override render() {
    const renderWidth = this.width ?? 'unsuported-css-unit';
    const renderHeight = this.height ?? 'unsuported-css-unit';

    let newWidth = DEFAULT_WIDTH;
    if (CSS.supports('width', renderWidth)) {
      newWidth = renderWidth;
    } else if (CSS.supports('height', renderHeight)) {
      newWidth = renderHeight;
    }

    const newHeight = CSS.supports('height', renderHeight)
      ? renderHeight
      : newWidth;

    return html`<div
      class="vn-skel-loading-shape"
      style="--vn-skeleton-shape-height:
      ${newHeight};
      --vn-skeleton-shape-width:
      ${newWidth};"
    >
      <slot></slot>
    </div>`;
  }

  static override styles = [
    ...super.styles,
    css`
      :host {
        --vn-skeleton-foreground-color: var(
          --vn-skeleton-effect-foreground-color__shape
        );
        --vn-skeleton-background-color: var(
          --vn-skeleton-effect-background-color__shape
        );
      }
      :host > div {
        width: var(--vn-skeleton-shape-width);
        height: var(--vn-skeleton-shape-height);
      }
      :host([theme-shape='round']) > div {
        border-radius: 4px;
      }
      :host([theme-shape='pill']) > div {
        border-radius: min(999vh, 36px);
      }
      :host([theme-shape='sharp']) > div {
        border-radius: 0px;
      }
      :host([shape='ellipse']) > div {
        border-radius: 100%;
      }
    `,
  ];
}

if (!customElements.get('veneer-skeleton-shape')) {
  customElements.define('veneer-skeleton-shape', VeneerSkeletonShape);
}

declare global {
  interface HTMLElementTagNameMap {
    'veneer-skeleton-shape': VeneerSkeletonShape;
  }
}
